import { RouteConfig } from "@/config/route.config";
import { DemoContext } from "@/providers/demo/DemoContext";

export interface NavLink {
  href: string;
  label: string;
  isExternal?: boolean;
}

export const useNavLinks = (): NavLink[] => {
  const { isDemoMode } = DemoContext.useDemo();

  const regularLinks: NavLink[] = [
    {
      href: RouteConfig.Profile,
      label: "Profile",
    },
    {
      href: RouteConfig.Watchlist,
      label: "Watchlist",
    },
    {
      href: RouteConfig.Analytics,
      label: "Analytics",
    },
    {
      href: RouteConfig.MyWallet,
      label: "My Wallet",
    },
    {
      href: RouteConfig.MyRewards,
      label: "My Rewards",
    },
    {
      href: RouteConfig.CeoVsEmployee,
      label: "CEO vs Employee",
    },
    {
      href: RouteConfig.VipPortfolios,
      label: "Portfolio",
    },
    {
      href: RouteConfig.Liveshow,
      label: "One Lucky Dog",
    },
    {
      href: RouteConfig.External.Swag,
      label: "Swag",
      isExternal: true,
    },
  ];

  const demoLinks: NavLink[] = [
    { href: RouteConfig.Demo.Profile, label: "Profile" },
    { href: RouteConfig.Demo.Watchlist, label: "Watchlist / Salary Profile" },
    { href: RouteConfig.Demo.Analytics, label: "Analytics" },
    { href: RouteConfig.Demo.MyWallet, label: "My Wallet" },
    { href: RouteConfig.Demo.MyRewards, label: "My Rewards" },
    { href: RouteConfig.Demo.CeoVsEmployee, label: "CEO vs Employee" },
    { href: RouteConfig.Demo.Portfolio, label: "Portfolio" },
    { href: RouteConfig.Demo.Liveshow, label: "One Lucky Dog" },
    { href: RouteConfig.External.Swag, label: "Swag", isExternal: true },
  ];

  return isDemoMode ? demoLinks : regularLinks;
};
